<template>
  <AnalyticsWidget
    title="Contact Monthly Minimum Spend"
    subTitle="Minimum spend details for contacts with active accounts and a minimum spend required amount set"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2 h-100">
      <ReportFilterPopover
        headerTitle="Minimum Spend Filter"
        :showApplyButton="true"
        :showResetButton="true"
        :appendToBody="true"
        alignment="left"
        placement="bottom-end"
        @apply="applyMinSpendFilter"
        @reset="resetMinSpendFilter">
        <template v-slot:popover>
          <ReportFilterGroup label="Date Filter">
            <ReportDateRangeSelect 
              :startDate="editingMinSpendFilter.startDate"
              :endDate="editingMinSpendFilter.endDate"
              @updateStartDate="editingMinSpendFilter.startDate = $event"
              @updateEndDate="editingMinSpendFilter.endDate = $event"
            />
          </ReportFilterGroup>
        </template>
        <template v-slot:filterDisplay>
          <div>
            <i class="far fa-calendar mr-2"></i>{{appliedMinSpendFilter.startDate | formatDate}} - {{appliedMinSpendFilter.endDate | formatDate}}
          </div>
        </template>
      </ReportFilterPopover>

      <LoadingPanel :loading="loading" />
      <Scroller v-if="!loading" :maxHeight="400">
        <StaticDataTable class="static-table-list" v-if="hasContacts">
          <template v-slot:header>
            <tr>
              <th>Contact</th>
              <th>Minimum Spend</th>
              <th>Min. Spend Admin Fee</th>
              <th v-for="month of monthList" :key="month.date">{{month.name}}</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="contact of contactList" :key="contact.id">
              <td>
                <LinkContact :id="contact.id" :name="contact.name" /></td>
              <td>{{formatCurrency(contact.minSpendRequired)}}</td>
              <td>{{formatCurrency(contact.minSpendAdminFee)}}</td>
              <td v-for="contactMonthInfo of contact.monthList" :key="contactMonthInfo.date">
                <span :class="contactMonthSpendClass(contact, contactMonthInfo.orderValue)">{{formatCurrency(contactMonthInfo.orderValue)}}</span>
              </td>              
            </tr>
          </template>
        </StaticDataTable>
        <div class="text-muted text-center font-italic" v-if="!hasContacts">No contacts under minimimum monthly spend found for date range</div>
        
      </Scroller>
    </div>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'

export default {
  name: 'ContactMinSpendWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow,
    ReportFilterPopover,
    ReportDateRangeSelect,
    ReportFilterGroup
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    hasContacts() {
      return this.contactList.length > 0
    },
    monthList() {
      if(this.contactList.length == 0)
        return []
      return this.contactList[0].monthList
    }
  },
  data() {
    return {
      loading: true,
      contactList: [],

      defaultMinSpendFilter: {    
        startDate: moment().local().subtract(6, 'months').startOf('month').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString(),
      },
      editingMinSpendFilter: {},
      appliedMinSpendFilter: {},
    }
  },
  mounted() {
    this.editingMinSpendFilter = _.clone(this.defaultMinSpendFilter)
    this.appliedMinSpendFilter = _.clone(this.defaultMinSpendFilter)

    this.loading = true
    this.requestData()
  },
  methods: {
    requestData() {
      var params = {
        startDate: this.appliedMinSpendFilter.startDate,
        endDate: this.appliedMinSpendFilter.endDate
      }

      this.$apiService.analyticsService.getContactMinSpendList(params)
      .then(response => {
        this.contactList = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    },
    applyMinSpendFilter() {
      this.appliedMinSpendFilter = _.clone(this.editingMinSpendFilter)

      this.reloadData()
    },
    resetMinSpendFilter() {
      this.editingMinSpendFilter = _.clone(this.defaultMinSpendFilter)
      this.appliedMinSpendFilter = _.clone(this.defaultMinSpendFilter)

      this.reloadData()
    },
    contactMonthSpendClass(contactInfo, orderValue) {
      if(orderValue >= contactInfo.minSpendRequired)
        return 'financial-profit'
      return 'financial-loss'
    }
    
  }
}
</script>